import React from "react";

const YTLect = ({ lectures }) => {
  if (lectures.length) {
    return lectures.map((v, i) => {
      return (
        <div key={v.title}>
          <h4>{v.title}</h4>
          <p>{v.description} </p>
          <iframe
            key={i}
            width="90%"
            height="450"
            style={{ margin: "1rem" }}
            src={v.link}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      );
    });
  }
  return <>No Video Record Found</>;
};
export default YTLect;
